// extracted by mini-css-extract-plugin
export var badge = "BadgeCounter-module--badge--20e9b";
export var content = "BadgeCounter-module--content--8e4e6";
export var maxNumber = "BadgeCounter-module--maxNumber--3d176";